import p1i1 from "../assets/image/p1i1.jpg"
import p1i2 from "../assets/image/p1i2.jpg"
import p1i3 from "../assets/image/p1i3.jpeg"
import p1i4 from "../assets/image/p1i4.jpeg"
import p1i5 from "../assets/image/p1i5.jpeg"
import p2i1 from "../assets/image/p2i1.jpeg"
import p2i2 from "../assets/image/p2i2.jpg"
import p2i3 from "../assets/image/p2i3.jpg"
import p3i1 from "../assets/image/p3i1.jpeg"
import p3i2 from "../assets/image/p3i2.jpg"
import p3i3 from "../assets/image/p3i3.jpg"
import p4i1 from "../assets/image/p4i1.jpeg"
import p4i2 from "../assets/image/p4i2.jpg"
import p4i3 from "../assets/image/p4i3.jpg"
import p4i4 from "../assets/image/p4i4.jpg"
import p4i5 from "../assets/image/p4i5.jpg"
import p5i1 from "../assets/image/p5i1.jpg"
import p5i2 from "../assets/image/p5i2.jpeg"
import p5i3 from "../assets/image/p5i3.jpeg"
import p61 from "../assets/image/61.jpg"
import p62 from "../assets/image/62.jpeg"
import p63 from "../assets/image/63.jpeg"
import p64 from "../assets/image/64.jpeg"
import p65 from "../assets/image/65.jpg"
import p71 from "../assets/image/71.jpg"
import p72 from "../assets/image/72.jpg"
import p73 from "../assets/image/73.jpeg"
import p74 from "../assets/image/74.jpg"
import p75 from "../assets/image/75.jpeg"
import p81 from "../assets/image/81.jpg"
import p82 from "../assets/image/82.jpg"
import p83 from "../assets/image/83.jpg"
import p84 from "../assets/image/84.jpg"
import integrity from "../assets/image/integrity.jpg"
import innovation from "../assets/image/innovation.png"
import sustainable from "../assets/image/sustainability.png"
import cottonvelvet from "../assets/image/Cotton-Velvet.jpg"
import satin from "../assets/image/SatinWeaving.jpg"
import synthetics from "../assets/image/Synthetics-Wool.jpg"
import stich from "../assets/image/stitch-fabric.jpg"




export const values = [
  {
    name: "Quality",
    description: "We are committed to delivering the highest quality fabrics to our customers.",
  },
  {
    name: "Sustainability",
    description: "We prioritize sustainable practices and materials throughout our supply chain.",
  },
  {
    name: "Innovation",
    description: "We constantly push boundaries to create cutting-edge designs and technologies.",
  },
  {
    name: "Customer Focus",
    description: "We put our customers at the heart of everything we do, providing exceptional service and support.",
  },
];

export const services = [
  {
    id: 1,
    name: "Stitch Fabric",
    description: "The material business is a significant worldwide Innovation with range occurring.",
    image: stich,
  },
  {
    id: 2,
    name: "Synthetics Wool",
    description: "The material business is a significant worldwide Innovation with range occurring.",
    image: synthetics,
  },
  {
    id: 3,
    name: "Cotton Velvet",
    description: "The material business is a significant worldwide Innovation with range occurring.",
    image: cottonvelvet,
  },
  {
    id: 4,
    name: "Satin Weaving",
    description: "The material business is a significant worldwide Innovation with range occurring.",
    image: satin,
  }
]

export const products = [
  {
    id: 1,
    name: 'Japan Satin Fabric',
    category: 'Textiles',
    price: 299,
    originalPrice: 399,
    rating: 4.5,
    reviews: 120,
    description:
      'Growtextile\'s Japan Satin Fabric boasts a smooth, glossy surface, providing a sophisticated and opulent look. Perfect for all occasions like weddings and parties.',
    stock: 50,
    images: [
      p1i1,p1i2, p1i3, p1i4,p1i5
    ],
    customerReviews: [
      { name: 'Alice Brown', rating: 5, comment: 'The fabric is luxurious!' },
      { name: 'John Doe', rating: 4, comment: 'Great for formal wear.' },
      { name: 'John Doe', rating: 4, comment: 'Great for formal wear.' },
      { name: 'John Doe', rating: 4, comment: 'Great for formal wear.' },
      { name: 'John Doe', rating: 4, comment: 'Great for formal wear.' },

    ],
  },
  {
    id: 2,
    name: 'Cotton Voile Fabric',
    category: 'Textiles',
    price: 199,
    originalPrice: 249,
    rating: 4.0,
    reviews: 80,
    description:
      'Lightweight and breathable, our Cotton Voile Fabric is perfect for summer garments and home decor.',
    stock: 40,
    images: [
     p2i1, p2i2, p2i3
    ],
    customerReviews: [
      { name: 'Mary Smith', rating: 4, comment: 'Perfect for lightweight dresses!' },
      { name: 'Mike Johnson', rating: 3, comment: 'Good quality, but a bit sheer.' },
    ],
  },
  {
    id: 3,
    name: 'Silk Chiffon Fabric',
    category: 'Textiles',
    price: 399,
    originalPrice: 499,
    rating: 4.8,
    reviews: 150,
    description:
      'Our Silk Chiffon Fabric is delicate and elegant, ideal for evening wear and formal attire.',
    stock: 30,
    images: [
      p3i1, p3i2, p3i3,
    ],
    customerReviews: [
      { name: 'Lucy Green', rating: 5, comment: 'Gorgeous fabric for my dress!' },
      { name: 'Paul White', rating: 4, comment: 'Slightly tricky to sew, but beautiful!' },
    ],
  },
  {
    id: 4,
    name: 'Linen Fabric',
    category: 'Textiles',
    price: 349,
    originalPrice: 399,
    rating: 4.2,
    reviews: 90,
    description:
      'Our Linen Fabric is breathable and perfect for warm weather. It drapes beautifully and adds texture to your garments.',
    stock: 25,
    images: [
     p4i1, p4i2, p4i3, p4i4, p4i5
    ],
    customerReviews: [
      { name: 'Jessica Taylor', rating: 4, comment: 'Great for summer clothing!' },
      { name: 'Chris Brown', rating: 4, comment: 'Wrinkles easily but looks great!' },
    ],
  },
  {
    id: 5,
    name: 'Georgette Fabric',
    category: 'Textiles',
    price: 249,
    originalPrice: 299,
    rating: 4.4,
    reviews: 110,
    description:
      'Georgette is a lightweight, sheer fabric with a slightly crinkled texture. Perfect for layering in your outfits.',
    stock: 35,
    images: [
     p5i1, p5i3, p5i2
    ],
    customerReviews: [
      { name: 'Karen Black', rating: 5, comment: 'Beautiful drape and flow!' },
      { name: 'Eric Miller', rating: 3, comment: 'A bit delicate, handle with care.' },
    ],
  },
  {
    id: 6,
    name: 'Cotton Sateen Fabric',
    category: 'Textiles',
    price: 299,
    originalPrice: 349,
    rating: 4.5,
    reviews: 130,
    description:
      'Our Cotton Sateen Fabric offers a soft, smooth finish and is perfect for creating chic clothing items.',
    stock: 20,
    images: [
     p61,p62,p63,p64,p65
    ],
    customerReviews: [
      { name: 'Tom Harris', rating: 5, comment: 'Lovely sheen and feels great!' },
      { name: 'Rachel Walker', rating: 4, comment: 'Great for making shirts.' },
    ],
  },
  {
    id: 7,
    name: 'Taffeta Fabric',
    category: 'Textiles',
    price: 199,
    originalPrice: 249,
    rating: 4.3,
    reviews: 85,
    description:
      'Taffeta is a crisp, lightweight fabric that is perfect for formal dresses and special occasions.',
    stock: 40,
    images: [
     p71,p72,p73,p74,p75
    ],
    customerReviews: [
      { name: 'David Young', rating: 4, comment: 'Perfect for evening gowns!' },
      { name: 'Sarah King', rating: 3, comment: 'A bit scratchy, but looks nice.' },
    ],
  },
  {
    id: 8,
    name: 'Canvas Fabric',
    category: 'Textiles',
    price: 150,
    originalPrice: 199,
    rating: 4.6,
    reviews: 90,
    description:
      'Our durable Canvas Fabric is ideal for making bags, outdoor gear, and home decor items.',
    stock: 50,
    images: [
     p81,p82,p83,p84
    ],
    customerReviews: [
      { name: 'Chris Evans', rating: 5, comment: 'Sturdy and reliable fabric!' },
      { name: 'Olivia Brown', rating: 4, comment: 'Great for DIY projects.' },
    ],
  },
  {
    id: 9,
    name: 'Denim Fabric',
    category: 'Textiles',
    price: 399,
    originalPrice: 499,
    rating: 4.7,
    reviews: 115,
    description:
      'Denim is a classic fabric known for its durability. Perfect for jeans, jackets, and casual wear.',
    stock: 30,
    images: [
      'https://picsum.photos/200/300?random=41',
      'https://picsum.photos/200/300?random=42',
      'https://picsum.photos/200/300?random=43',
      'https://picsum.photos/200/300?random=44',
      'https://picsum.photos/200/300?random=45',
    ],
    customerReviews: [
      { name: 'Ben White', rating: 5, comment: 'Love the quality of this denim!' },
      { name: 'Emma Watson', rating: 4, comment: 'Sturdy and perfect for jeans.' },
    ],
  },
  // {
  //   id: 10,
  //   name: 'Fleece Fabric',
  //   category: 'Textiles',
  //   price: 250,
  //   originalPrice: 299,
  //   rating: 4.4,
  //   reviews: 100,
  //   description:
  //     'Fleece Fabric is soft, warm, and perfect for jackets and blankets. A must-have for winter wear.',
  //   stock: 20,
  //   images: [
  //     'https://picsum.photos/200/300?random=46',
  //     'https://picsum.photos/200/300?random=47',
  //     'https://picsum.photos/200/300?random=48',
  //     'https://picsum.photos/200/300?random=49',
  //     'https://picsum.photos/200/300?random=50',
  //   ],
  //   customerReviews: [
  //     { name: 'Sophia Garcia', rating: 5, comment: 'Super warm and comfy!' },
  //     { name: 'Liam Brown', rating: 4, comment: 'Great for winter jackets!' },
  //   ],
  // },
];

export const featuredProducts = [
  {
    id: 1,
    name: 'Cotton Fabric',
    image: 'https://picsum.photos/200/300?random=1',
  },
  {
    id: 2,
    name: 'Linen Fabric',
    image: 'https://picsum.photos/200/300?random=2',
  },
  {
    id: 3,
    name: 'Silk Fabric',
    image: 'https://picsum.photos/200/300?random=3',
  },
  {
    id: 4,
    name: 'Wool Fabric',
    image: 'https://picsum.photos/200/300?random=4',
  },
  {
    id: 5,
    name: 'Denim Fabric',
    image: 'https://picsum.photos/200/300?random=5',
  },
  {
    id: 6,
    name: 'Polyester Fabric',
    image: 'https://picsum.photos/200/300?random=6',
  },
  {
    id: 7,
    name: 'Rayon Fabric',
    image: 'https://picsum.photos/200/300?random=7',
  },
  {
    id: 8,
    name: 'Chiffon Fabric',
    image: 'https://picsum.photos/200/300?random=8',
  },
  {
    id: 9,
    name: 'Velvet Fabric',
    image: 'https://picsum.photos/200/300?random=9',
  },
  {
    id: 10,
    name: 'Hemp Fabric',
    image: 'https://picsum.photos/200/300?random=10',
  },
];


export const teamMembers = [
  {
    name: "John Doe",
    role: "CEO & Founder",
    image: "path/to/john-doe-image.jpg",
    description: "John is a visionary entrepreneur with a passion for textiles and sustainable manufacturing.",
  },
  {
    name: "Jane Smith",
    role: "Chief Design Officer",
    image: "path/to/jane-smith-image.jpg",
    description: "Jane leads our design team, creating innovative and trendsetting fabric collections.",
  },
  // Add more team members...
];

export const navHeaders = [
  {
    id: 1,
    name: "Home",
    path: "/"
  },
  {
    id: 2,
    name: "About Us",
    path: "/about"
  },
  {
    id: 3,
    name: "Products",
    path: "/products"
  },
  {
    id: 4,
    name: "Category",
    path: "/category"
  },
  {
    id: 5,
    name: "Contact",
    path: "/contact"
  },
];

export const productCategories = [
  {
    id: 'yarns',
    name: 'Yarns',
    image: 'https://www.contrado.co.uk/blog/wp-content/uploads/2020/01/feature-image-copy-886x550.jpg'
  },
  {
    id: 'fabrics',
    name: 'Fabrics',
    image: 'https://www.cheersagar.com/images/blog/16275685815164.jpg'
  },
  {
    id: 'materials',
    name: 'Materials',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRB7zNLYuwbR0JT5aPS_MQ-e757VR_HYiiZNw&s'
  },
  // Add more categories as needed
];

export const wishlistItems = [
  {
    id: 1,
    name: "Cotton Fabric Roll",
    price: 299.99,
    image: cottonvelvet,
    description: "High-quality cotton fabric, perfect for summer wear",
  },
  {
    id: 2,
    name: "Cotton Fabric Roll",
    price: 299.99,
      image: satin,
    description: "High-quality cotton fabric, perfect for summer wear",
  },
  {
    id: 3,
    name: "Cotton Fabric Roll",
    price: 299.99,
    image: synthetics,
    description: "High-quality cotton fabric, perfect for summer wear",
  },
];
